import { HeadingTitle } from "Components/HeadingTitle";
import { PageNumberSubtitle } from "Components/PageNumber";
import React from "react";
import { PageNumberProps } from "SharedConstants/Schema";

export function Heading(props: {
  PageNumberProps?: PageNumberProps;

  title?: React.ReactNode;
}) {
  return (
    <>
      <HeadingTitle>{props.title}</HeadingTitle>
      {props.PageNumberProps && (
        <PageNumberSubtitle {...props.PageNumberProps} />
      )}
    </>
  );
}
